export default function PHP_soundex() {
  return (
    <div>
      <h1>PHP_soundex</h1>
    </div>
  );
}
